module.exports = __webpack_public_path__ + "static/media/apple_button.98306891.png";